import { getPageThemeQuery, getPageProfileQuery } from '@redlink/services';

export const freshCacheForRemoveItem = () => (
  cache,
  { data: { RemoveTheme: id } }
) => {
  let { Themes: oldData } = cache.readQuery({
    query: getPageThemeQuery,
  });

  cache.writeQuery({
    query: getPageThemeQuery,
    data: {
      Themes: [...oldData.filter((p) => p.id !== id)],
    },
  });
};

export const freshCacheForSetAsDefaultItem = () => (cache, { data }) => {
  const freshData = data.SetThemeAsDefault;

  const { PageProfile: oldData } = cache.readQuery({
    query: getPageProfileQuery,
  });

  cache.writeQuery({
    query: getPageProfileQuery,
    data: {
      PageProfile: {
        ...oldData,
        settings: { ...oldData.settings, currentTheme: freshData },
      },
    },
  });
};
